import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=6922215f&scoped=true"
import script from "./AddCourse.vue?vue&type=script&lang=js"
export * from "./AddCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922215f",
  null
  
)

export default component.exports